import ApiService from '../../api/api';
import Vuex from 'vuex';
import Vue from 'vue';

Vue.use(Vuex);

export default {
    namespaced: true,
    state() {
        return {
            redirects: [],
            pages: [],
            activeTab: 'page-redirect',
        }
    },
    getters: {
        activeTab: (state) => state.activeTab,
        pages: (state) => state.pages,
    },
    mutations: {
        setRedirects(state, value) {
            state.redirects = value;
        },
        addRedirect(state, value) {
            state.redirects.data.unshift(value);
        },
        removeRedirect(state, item) {
            for (let i = 0; i < state.redirects.data.length; i++) {
                if (state.redirects.data[i].id === item.id) {
                    window.Vue.delete(state.redirects.data, i, item);
                }
            }
        },
        updateRedirect(state, item) {
            for (let i = 0; i < state.redirects.data.length; i++) {
                if (state.redirects.data[i].id === item.id) {
                    window.Vue.set(state.redirects.data, i, item);
                }
            }
        },
        setActiveTab(state, value) {
            state.activeTab = value;
        },
    },
    actions: {
        index({state, commit, getters}, payload = {}) {
            return new Promise((resolve, reject) => {
                ApiService.get('/page/redirect', payload)
                  .then((response) => {
                      commit('setRedirects', response.data);
                      resolve(response);
                  })
                  .catch((error) => {
                      reject(error);
                      console.log(error);
                  });
            });
        },
        pageSearch({state, commit, getters}, payload) {
          return new Promise((resolve, reject) => {
            ApiService.post('/search-page', payload)
              .then((response) => {
                state.pages = response.data;
                resolve(response);
              })
              .catch((error) => {
                reject(error);
                console.log(error);
              });
          });
        },
        create({state, commit, getters}, payload) {
            return new Promise((resolve, reject) => {
                ApiService.post('/page/redirect', payload)
                  .then((response) => {
                      commit('addRedirect', response.data);
                      resolve(response);
                  })
                  .catch((error) => {
                      reject(error);
                      console.log(error);
                  })
            });
        },
        update({state, commit, getters}, payload) {
            return new Promise((resolve, reject) => {
                ApiService.update('/page/redirect/' + payload.id, payload)
                  .then((response) => {
                      commit('updateRedirect', response.data);
                      resolve(response);
                  })
                  .catch((error) => {
                      reject(error);
                      console.log(error);
                  });
            });
        },
        deleteItem({state, commit, getters}, id) {
            return new Promise((resolve, reject) => {
                ApiService.delete('/page/redirect/' + id)
                  .then((response) => {
                      commit('removeRedirect', response.data);
                      resolve(response);
                  })
                  .catch((error) => {
                      reject(error);
                      console.log(error);
                  });
            });
        },
        restoreItem({state, commit, getters}, id) {
            return new Promise((resolve, reject) => {
                ApiService.get('/page/redirect/' + id + '/restore')
                  .then((response) => {
                      commit('removeRedirect', response.data);
                      resolve(response);
                  })
                  .catch((error) => {
                      reject(error);
                      console.log(error);
                  });
            });
        },
    }
};
